import { render, staticRenderFns } from "./VariantSelector.vue?vue&type=template&id=a7a6be28"
import script from "./VariantSelector.vue?vue&type=script&lang=js"
export * from "./VariantSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports